<script setup lang="ts">
import { customElementPropsKey } from '@/types/customElementProps.types'
import { computed, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useRealmSettings } from '@/stores/useRealmSettings'
import PageTitle from '@/components/PageTitle.vue'

const templateProps = inject(customElementPropsKey)
const { realmSettings } = storeToRefs(useRealmSettings())

const mailToLink = computed(() => {
  return `mailto:${realmSettings.value?.email.technical_support_email}`
})
</script>

<template>
  <div>
    <PageTitle :title="$t('error-page.expired.title')" />
    <div class="d-flex flex-column gap-4">
      <p class="text-center">{{ $t('error-page.expired.message') }}</p>
      <v-btn :href="templateProps?.loginRestartFlowUrl">{{
        $t('error-page.expired.button')
      }}</v-btn>
      <v-btn variant="text" :href="mailToLink" target="_blank">{{
        $t('error-page.contact.button')
      }}</v-btn>
    </div>
  </div>
</template>
